import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-c4-four-one-two-one',
  templateUrl: './c4-four-one-two-one.component.html',
  styleUrls: ['./c4-four-one-two-one.component.scss']
})
export class C4FourOneTwoOneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
